import React, { forwardRef } from 'react'
import clsx from 'clsx'

/**
 * Text field used in entity / customer typeahead rows. Forwards ref for focus and click-outside handling.
 */
export type EntitySearchInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  inputClassName?: string
}

export const EntitySearchInput = forwardRef<HTMLInputElement, EntitySearchInputProps>(
  ({ className, inputClassName, type = 'text', autoComplete = 'off', ...rest }, ref) => (
    <input ref={ref} type={type} autoComplete={autoComplete} className={clsx(inputClassName, className)} {...rest} />
  ),
)
EntitySearchInput.displayName = 'EntitySearchInput'
